import { render, staticRenderFns } from "./HappyTable32Inch.vue?vue&type=template&id=ebd031d0&scoped=true"
import script from "./HappyTable32Inch.vue?vue&type=script&lang=js"
export * from "./HappyTable32Inch.vue?vue&type=script&lang=js"
import style0 from "./HappyTable32Inch.vue?vue&type=style&index=0&id=ebd031d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd031d0",
  null
  
)

export default component.exports